import * as React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import ErrorView from '@components/ErrorView';
import { ThemeProvider } from '@context/ThemeContext';
import { logError } from '@helpers/Loggers';

const errorHandler = (error: unknown) => {
  logError(error);
};

function ErrorFallback() {
  return (
    <ThemeProvider>
      <ErrorView tapToReload />
    </ThemeProvider>
  );
}

type ErrorBoundaryProps = { children: React.ReactNode };

export function ErrorBoundary({ children }: ErrorBoundaryProps) {
  return (
    <ReactErrorBoundary FallbackComponent={ErrorFallback} onError={errorHandler}>
      {children}
    </ReactErrorBoundary>
  );
}
